import React from "react";

// css
import "./InvestmentsStyles.css";

const InvestmentsHeader = () => {
  return (
    <section
      className="investments-header-container relative"
      id="investments-header"
    >
      <div className="text-white p-5 md:px-20">
        <div className="main-margin">
          <h1 className="main-header">Investments</h1>
          <div className="absolute bottom-4 right-4">
            <p className="text-white text-sm">
              Asset pictures is the St. Louis Data Center owned by DIR
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentsHeader;
